module.exports = __webpack_public_path__ + "img/RegisterApp3.a6ff3e45.png";